import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment FaqSideBySideData on StrapiComponentFaqSideBySide {
    topic
    title
    description
    questions {
      question
      answer
    }
  }
`;

function SideBySide({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-off-white">
      <div className="mx-auto max-w-7xl divide-y divide-divide-light px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div>
          {data.topic && (
            <h3 className="block text-base font-semibold uppercase tracking-wide text-text-secondary">
              <MarkdownWrapper text={data.topic} />
            </h3>
          )}
          {data.title && (
            <h2 className="text-3xl font-extrabold text-text-primary">
              <MarkdownWrapper text={data.title} />
            </h2>
          )}
          {data.description && (
            <MarkdownWrapper
              text={data.description}
              markdownClassName="mt-4 text-lg text-text-secondary"
              replaceParagraph={false}
            />
          )}
        </div>
        {Boolean(data.questions?.length) && (
          <div className="mt-8">
            <dl className="divide-y divide-divide-light">
              {data.questions.map((faq, index) => (
                <div
                  key={index}
                  className="pb-8 pt-6 md:grid md:grid-cols-12 md:gap-8"
                >
                  {faq.question && (
                    <dt className="text-base font-medium text-text-secondary-dark md:col-span-5">
                      <MarkdownWrapper text={faq.question} />
                    </dt>
                  )}
                  {faq.answer && (
                    <dd className="mt-2 md:col-span-7 md:mt-0">
                      <MarkdownWrapper
                        text={faq.answer}
                        markdownClassName="text-base text-text-secondary prose"
                        replaceParagraph={false}
                      />
                    </dd>
                  )}
                </div>
              ))}
            </dl>
          </div>
        )}
      </div>
    </div>
  );
}

SideBySide.propTypes = {
  data: PropTypes.object,
};

export default SideBySide;
